import { forwardRef, type MouseEvent } from "react";

type Props = {
  className?: string;
  onClick?: (e: MouseEvent) => void;
};
export const ShoppingBasket = forwardRef<SVGSVGElement, Props>(({ className, onClick }, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={className}
    onClick={onClick}
    ref={ref}
  >
    <path
      fill="currentColor"
      d="M12 2a6 6 0 0 1 6 6v1h4v2h-1.17l-.75 9.08a1 1 0 0 1-1 .92H4.92a1 1 0 0 1-1-.92L3.17 11H2V9h4V8a6 6 0 0 1 6-6Zm6.83 9H5.17l.67 8h12.32l.67-8ZM13 13v4h-2v-4h2Zm-4 0v4H7v-4h2Zm8 0v4h-2v-4h2Zm-5-9a4 4 0 0 0-4 3.8V9h8V8a4 4 0 0 0-3.8-4H12Z"
    />
  </svg>
));
